import { useDispatch, useSelector } from 'react-redux';
import dynamicfunction from '../../utils/dynamicfunction';
import { getContentKeyAccToLang } from '../../utils/utils';
import { useNavigate } from 'react-router';
import { useEffect } from 'react';
import { getTicketingHistory } from '../../store/actions/settingAction';

export default () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { TextWeight, isArabic, direction } = dynamicfunction();
  const { helpContent } = useSelector((state) => state.content);
  const { clientDetails } = useSelector((state) => state.investments);
  const { ticketing_history, ticketing_history_loading } = useSelector(
    (state) => state.setting
  );

  useEffect(() => {
    dispatch(
      getTicketingHistory(clientDetails?.clientInformation?.clientEmail)
    );
  }, []);
  
  const getContentKey = (key) => {
    return getContentKeyAccToLang(
      helpContent?.ticketing_history?.data?.attributes,
      key,
      isArabic
    );
  };

  return {
    TextWeight,
    getContentKey,
    navigate,
    isArabic,
    direction,
    ticketing_history,
    ticketing_history_loading,
  };
};
